import { render, staticRenderFns } from "./BooksList.vue?vue&type=template&id=2da7f0e0&"
import script from "./BooksList.vue?vue&type=script&lang=ts&"
export * from "./BooksList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports